<template>
  <el-select
    v-model="languageVal"
    placeholder="Select"
    size="small"
    class="lang-toggle"
    :class="`lang-toggle-${variant}`"
    @change="changeLang"
  >
    <el-option
      v-for="lang in filteredLangOptions"
      :key="lang.value"
      :value="lang.value"
      :label="lang.label"
    />
    <!-- <el-option :label="$t('fields.vietnamese')" :value="'vi'" />
    <el-option :label="$t('fields.english')" :value="'en'" /> -->
  </el-select>
</template>

<script setup>
import { defineProps, computed } from 'vue'
import { i18nStore } from '@/store/language'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  // eslint-disable-next-line vue/require-default-prop
  langList: {
    type: Array,
    required: false,
  },
  variant: {
    type: String,
    default: 'select',
  },
});

const { t } = useI18n()
const i18nStoreLanguage = i18nStore()
const { languageVal } = storeToRefs(i18nStoreLanguage)

const langOptions = [
  { label: t('fields.vietnamese'), value: 'vi' },
  { label: t('fields.english'), value: 'en' },
  { label: t('fields.chinese'), value: 'zh' },
]

const filteredLangOptions = computed(() => {
  return langOptions.filter((lang) => {
    return props.langList.includes(lang.value)
  })
})
const changeLang = newLang => {
  i18nStoreLanguage.setLanguage(newLang)
}
</script>
<style lang="scss" scoped>
.lang-toggle {
  &.lang-toggle-select {
    position:absolute;
    top:10px;
    right:25px;
    width:120px;
  }
  &.lang-toggle-button {
    :deep(.el-input) {
      .el-input__inner {
        background: linear-gradient(180deg, #73B2FF 0%, #3981FF 100%);
        box-shadow: 0px -2px 4.58px 0px #93C7FF inset, 0px -1px 3.66px 0px #275EC1 inset;
        border: none;
        color: #fff;
        text-align: center;
        padding: 0 16px;
      }
      .el-input__suffix {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .lang-toggle {
    &.lang-toggle-button {
      :deep(.el-input) {
        font-size: .75rem;
        line-height: 23px;
        .el-input__inner {
          height: 23px;
        }
      }
    }
  }
}
</style>
